import React from 'react'

// material ui
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// local components
import DiscountDetails from './DiscountDetails'
import ProductInfoLink from './ProductInfoLink'
import SummerPassProductInfo from './SummerPassProductInfo'

// helpers
import { centsToDollars } from 'lib/helpers/money'
import {
  summerPassRetailPrice,
  summerPassUpgradePrice,
  summerPassDiscountAmount,
  summerPassDiscountCategory
} from 'lib/cart/decorators/cartProduct'

const SummerPassProduct = ({
  product,
  camperSession,
  volumeDiscountPriceCents,
  camper,
  session,
  cartProduct,
  account
}) => {
  if (!camperSession) {
    return null
  }

  // cost to upgrade to a summer pass
  const upgradePriceCents = summerPassUpgradePrice(cartProduct, account)

  // full retail price for a summer pass
  const unlimitedPriceCents = summerPassRetailPrice(cartProduct)

  // account discount reduction off the summer pass price
  const upgradeDiscountCents = summerPassDiscountAmount(cartProduct)
  const discountCategory = summerPassDiscountCategory(cartProduct)

  // credit for existing days
  const upgradeCreditCents =
    unlimitedPriceCents - upgradeDiscountCents - upgradePriceCents

  // determine if there is a discount or credit
  const hasDiscount = upgradePriceCents < unlimitedPriceCents

  // modal
  const modalId = `product-info-${camper.id}-${session.id}-${product.id}-summer-pass`
  const modalTitle = `${product.unlimitedDescription} - ${centsToDollars(
    volumeDiscountPriceCents * product.breakEvenDays
  )}`

  return (
    <Box display='flex' alignItems='center' my={1}>
      <Typography component='div' variant='body1'>
        {product.unlimitedDescription}{' '}
        {upgradeCreditCents > 0 ? 'Upgrade' : null} –{' '}
        {centsToDollars(upgradePriceCents)}
        {hasDiscount && (
          <DiscountDetails>
            ({centsToDollars(unlimitedPriceCents)}
            {upgradeDiscountCents > 0 &&
              ` - ${centsToDollars(
                upgradeDiscountCents
              )} ${discountCategory} discount`}
            {upgradeCreditCents > 0 &&
              ` - ${centsToDollars(upgradeCreditCents)} credit`}
            )
          </DiscountDetails>
        )}
      </Typography>

      {/* modal */}
      <ProductInfoLink modalId={modalId} />
      <SummerPassProductInfo
        modalId={modalId}
        modalTitle={modalTitle}
        product={product}
        session={session}
        volumeDiscountPriceCents={volumeDiscountPriceCents}
      />
    </Box>
  )
}

export default SummerPassProduct
